import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBanner, IBannerInitialState } from "./bannerModel";
import {
  ActiveInactiveBanner,
  BannerDetailsImageUpload,
  createBanner,
  deleteBanner,
  getAllActiveBanner,
  getAllBanner,
  getBannerByID,
  updateBanner,
} from "./services/banner.services";

const initialState: IBannerInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  BannerID: null,
  BannerList: [],
  BannerDetail: {
    ID: null,
    BannerType: "",
    BannerTitle: "",
    SubTitle: "",
    BannerImage: "",
    AltTitle: "",
    Description: "",
    IsActive: 1,
  },
};

const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    clearBannerDetails: (state) => {
      state.BannerDetail = initialState.BannerDetail;
    },
    setBannerID: (state, action) => {
      state.BannerID = action.payload;
    },
    clearBannerID: (state) => {
      state.BannerID = initialState.BannerID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllBanner.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllBanner.fulfilled,
      (state, action: PayloadAction<IBanner[]>) => {
        state.loading = false;
        state.BannerList = action.payload || [];
      }
    );
    builder.addCase(getAllBanner.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BannerList = [];
    });
    builder.addCase(createBanner.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(createBanner.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createBanner.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateBanner.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(updateBanner.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateBanner.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteBanner.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBanner.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBanner.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getBannerByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getBannerByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.BannerDetail = action.payload;
    });
    builder.addCase(getBannerByID.rejected, (state, action) => {
      state.loading = false;
      state.BannerDetail = initialState.BannerDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveBanner.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveBanner.fulfilled,
      (state, action: PayloadAction<IBanner[]>) => {
        state.loading = false;
        state.BannerList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveBanner.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BannerList = [];
    });
    builder.addCase(ActiveInactiveBanner.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveBanner.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveBanner.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(BannerDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(BannerDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(BannerDetailsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearBannerDetails, clearBannerID, setBannerID } =
  bannerSlice.actions;
export default bannerSlice.reducer;
